import { render } from "./BasketIcon.vue?vue&type=template&id=75d644a6"
import script from "./BasketIcon.vue?vue&type=script&lang=js"
export * from "./BasketIcon.vue?vue&type=script&lang=js"

import "./BasketIcon.vue?vue&type=style&index=0&id=75d644a6&lang=scss"

import exportComponent from "/codebuild/output/src1609179274/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__